<template>

    <div class="row">
        <div class="col-sm-4 col-sm-offset-4">
            <div class="box box-solid">
                <div class="box-header">
                    <h2 class="box-title">CRM Groepen</h2>
                    <div class="box-tools">
                        <router-link
                            class="btn btn-primary btn-xs pull-right"
                            :to="{name:'crm.groups.add'}"
                        >
                            <i class="fa fa-plus"></i>
                        </router-link>
                    </div>
                </div>
                <div class="box-body no-padding">
                    <table class="table table-striped">
                        <thead>
                            <tr>
                                <th>Naam</th>
                                <th>Aantal elementen</th>
                                <th>&nbsp;</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-if="getCrmGroups.length === 0">
                                <td colspan="3">Er zijn geen CRM groepen gevonden</td>
                            </tr>
                            <tr
                                v-for="crmgroup in getCrmGroups"
                                :id="'row-' + crmgroup.uuid"
                            >
                                <td>{{ crmgroup.name }}</td>
                                <td>{{ crmgroup.element_count }}</td>
                                <td class="text-right">
                                    <div class="btn-group btn-group-xs">
                                        <router-link
                                            :to="{name:'crm.groups.show', params: {uuid: crmgroup.uuid}}"
                                            class="btn btn-default"
                                            v-tooltip="'CRM Groep bekijken'"
                                        >
                                            <i class="mdi mdi-eye"></i>
                                        </router-link>
                                        <router-link
                                            :to="{name:'crm.groups.edit', params: {uuid: crmgroup.uuid}}"
                                            class="btn btn-primary"
                                            v-tooltip="'CRM Groep bewerken'"
                                        >
                                            <i class="mdi mdi-pencil"></i>
                                        </router-link>
                                        <delete-button
                                            v-tooltip="'CRM Groep verwijderen'"
                                            :parent-element="'row-' + crmgroup.uuid"
                                            :url="route('api.v1.crm.groups.destroy', {group_uuid:crmgroup.uuid})"
                                            :name="crmgroup.name"
                                            title="CrmGroup"
                                            :disabled="loading"
                                            @delete-starting="setLoading"
                                            @delete-completed="unsetLoading"
                                            @delete-cancelled="unsetLoading"
                                        ></delete-button>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                <div class="box-footer">
                    <div class="text-right">
                        <!--<a :href="route('crm.groups.add')" class="btn btn-primary btn-xs">
                            <i class="fa fa-plus"></i>
                        </a>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

import { mapGetters } from 'vuex';

export default {

    computed: {

        ...mapGetters([
            'getCrmGroups',
        ]),

    },

    data() {
        return {
            loading:false,
        }
    },

    metaInfo: {
        title:'CRM Groepen',
    },

    methods: {
        setLoading() {
            this.loading = true;
        },
        unsetLoading() {
            this.loading = false;
        },
    },

    name:'CrmGroupsIndex',

}

</script>
